import React from 'react';

import './loginBackground.scss';
import backgroundImage from 'assets/login-background.svg';
import loginFormImage from 'assets/login-page-illustration.png';
import loginFormImage2x from 'assets/login-page-illustration@2x.png';
import { PrivacyPolicy } from 'components/PrivacyPolicy/PrivacyPolicy';
import className from 'classnames';
import { getAsset, resolveAsset } from 'utils/themeConfig';

export const LoginBackground = ({ children }) => {
  const formImageStyle = className('form-image', {
    fill: true
  });
  const illustrationOverride = getAsset('login-page-illustration');
  const illustration2xOverride = getAsset('login-page-illustration@2x');
  return (
    <div className='login-background'>
      <img
        className='right-top'
        src={resolveAsset('login-background', backgroundImage)}
        alt='right top decorator'
      />
      <img
        className='left-bottom'
        src={resolveAsset('login-background', backgroundImage)}
        alt='left bottom decorator'
      />
      <div className='form-container'>
        <img
          className={formImageStyle}
          src={illustrationOverride ?? loginFormImage}
          srcSet={
            illustrationOverride
              ? illustration2xOverride
              : `${loginFormImage2x} 2x`
          }
          alt='illustration'
        />
        {children}
        <PrivacyPolicy className='loginPagePrivacyPolicy' />
      </div>
    </div>
  );
};
